function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("circle", {
  cx: 11,
  cy: 11,
  r: 10.5,
  stroke: "#7E0404"
});

var _ref3 = /*#__PURE__*/React.createElement("path", {
  d: "M9.96631 15.8984C9.7124 15.6615 9.58545 15.3335 9.58545 14.9146C9.58545 14.4956 9.7124 14.1698 9.96631 13.937C10.2244 13.7 10.5291 13.5815 10.8804 13.5815C11.2316 13.5815 11.5342 13.7 11.7881 13.937C12.0462 14.1698 12.1753 14.4956 12.1753 14.9146C12.1753 15.3335 12.0462 15.6615 11.7881 15.8984C11.5342 16.1312 11.2316 16.2476 10.8804 16.2476C10.5291 16.2476 10.2244 16.1312 9.96631 15.8984ZM10.4932 12.147C10.4001 11.7492 10.2414 11.1546 10.0171 10.3633C9.79281 9.56771 9.61296 8.88639 9.47754 8.31934C9.34212 7.74805 9.27441 7.31852 9.27441 7.03076C9.27441 6.59066 9.43099 6.25 9.74414 6.00879C10.0573 5.76758 10.4318 5.64697 10.8677 5.64697C11.312 5.64697 11.6971 5.77181 12.0229 6.02148C12.353 6.26693 12.5181 6.60758 12.5181 7.04346C12.5181 7.33968 12.4461 7.77555 12.3022 8.35107C12.1584 8.9266 11.9722 9.60368 11.7437 10.3823C11.5151 11.1567 11.3543 11.745 11.2612 12.147C11.2274 12.2866 11.1745 12.3945 11.1025 12.4707C11.0348 12.5426 10.9608 12.5786 10.8804 12.5786C10.7957 12.5786 10.7174 12.5426 10.6455 12.4707C10.5778 12.3945 10.527 12.2866 10.4932 12.147Z",
  fill: "#7E0404"
});

function SvgErrorIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 22,
    viewBox: "0 0 22 22",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2, _ref3);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgErrorIcon);
export default __webpack_public_path__ + "static/media/errorIcon.9fa70568.svg";
export { ForwardRef as ReactComponent };